var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Shop By Marker")]),_c('ul',{staticClass:"menu"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Marker 1")])],1),_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Marker 2")])],1),_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Marker 3")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }